import React from 'react'
import DateCell from "@blocks/DateCell";
import { Column } from "react-table";
import _ from 'lodash';

export default [
    { 
        Header: 'Salon',
        accessor: 'salon.name',
        width: '100%'
    },
    {
        Header: 'Organizations',
        accessor: 'salon.patronages',
        Cell: ({ value: patronages }: { value: Resources.CurrentSalon["patronages"] }) => {
            const organizations = _.uniq(patronages.map(patronage => patronage.organization?.name)).join(', ')
            return <span>{organizations}</span>
        }
    },
    {
        Header: 'Closing date',
        accessor: 'salon.closing_date',
        Cell: DateCell
    },
    { 
        Header: 'Discount',
        accessor: 'discount',
        Cell: ({ value }: any) => <span>{value}%</span>
    }
] as Column<Resources.ClubPromo>[]